import { Trans } from '@lingui/react'
import { string } from 'prop-types'

import { OFFER_PROMOTION_TYPES } from 'shared/consts/marketplace'
import { PRESCRIPTION_TYPES } from 'shared/consts/productTemplates'

const PrescriptionTypeTranslation = ({ prescriptionType }) => {
  switch (prescriptionType) {
    case PRESCRIPTION_TYPES.PRIVAT:
      return <Trans id="product-listing.prescription.privatePrescription" />
    case PRESCRIPTION_TYPES.FREE:
      return <Trans id="product-listing.prescription.freePrescription" />
    case PRESCRIPTION_TYPES.INSURANCE:
      return <Trans id="product-listing.prescription.insurancePrescription" />
    case PRESCRIPTION_TYPES.NO_PRESCRIPTION:
      return <Trans id="product-listing.prescription.noPrescription" />
    case PRESCRIPTION_TYPES.ODS:
      return <Trans id="product-listing.prescription.ODSPrescription" />
    case PRESCRIPTION_TYPES.ERX:
      return <Trans id="product-listing.prescription.eRxPrescription" />
    case PRESCRIPTION_TYPES.GRATIS:
    case OFFER_PROMOTION_TYPES.FREEBIE:
      return <Trans id="product-listing.section.bonusSection" />
    default:
      return prescriptionType
  }
}

PrescriptionTypeTranslation.propTypes = {
  prescriptionType: string.isRequired,
}

export default PrescriptionTypeTranslation
